import { createLogger } from '@wtc/logger';

export const logger = createLogger({ service: 'hub' });
export type { Logger } from '@wtc/logger';
